import type { PluginOption } from 'vite';

export function fbjsHotfixPlugin(): PluginOption {
  return {
    name: 'fbjs-hotfix',
    transform(code, id) {
      if (id.endsWith('node_modules/fbjs/lib/UnicodeBidi.js')) {
        return {
          code: code.replaceAll('\\u17D8', ''),
        };
      }

      return null;
    },
  };
}
